var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "activity-detail-container" }, [
    _c("div", { staticClass: "detail-section" }, [
      _vm._m(0),
      _c("div", { staticClass: "section-content" }, [
        _c("div", { staticClass: "info-grid" }, [
          _c("div", { staticClass: "info-item" }, [
            _c("span", { staticClass: "info-label" }, [_vm._v("状态")]),
            _c(
              "span",
              { staticClass: "info-value" },
              [
                _c(
                  "el-tag",
                  {
                    attrs: {
                      type: _vm.getStatusType(_vm.activityData.status),
                      size: "medium",
                    },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.getStatusText(_vm.activityData.status)) +
                        " "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "info-item" }, [
            _c("span", { staticClass: "info-label" }, [_vm._v("活动名称")]),
            _c("span", { staticClass: "info-value" }, [
              _vm._v(_vm._s(_vm.activityData.activityName || "暂无")),
            ]),
          ]),
          _c("div", { staticClass: "info-item" }, [
            _c("span", { staticClass: "info-label" }, [_vm._v("招募摊位数")]),
            _c("span", { staticClass: "info-value" }, [
              _vm._v(_vm._s(_vm.activityData.needCount || 0) + "个"),
            ]),
          ]),
          _c("div", { staticClass: "info-item" }, [
            _c("span", { staticClass: "info-label" }, [_vm._v("已报名人数")]),
            _c("span", { staticClass: "info-value" }, [
              _vm._v(_vm._s(_vm.activityData.applyCount || 0) + "人"),
            ]),
          ]),
          _c("div", { staticClass: "info-item" }, [
            _c("span", { staticClass: "info-label" }, [_vm._v("浏览数据")]),
            _c("span", { staticClass: "info-value" }, [
              _vm._v(_vm._s(_vm.activityData.readCount || 0) + "次"),
            ]),
          ]),
          _c("div", { staticClass: "info-item" }, [
            _c("span", { staticClass: "info-label" }, [_vm._v("进程状态")]),
            _c(
              "span",
              { staticClass: "info-value" },
              [
                _c(
                  "el-tag",
                  {
                    attrs: {
                      type: _vm.getProcessStatusType(
                        _vm.activityData.processStatus
                      ),
                      size: "mini",
                    },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.getProcessStatusName(
                            _vm.activityData.processStatus
                          )
                        ) +
                        " "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "detail-section" }, [
      _vm._m(1),
      _c("div", { staticClass: "section-content" }, [
        _c("div", { staticClass: "info-grid" }, [
          _c("div", { staticClass: "info-item" }, [
            _c("span", { staticClass: "info-label" }, [_vm._v("报名时间")]),
            _c("span", { staticClass: "info-value" }, [
              _vm._v(
                _vm._s(
                  _vm.formatTimeRange(
                    _vm.activityData.startTime,
                    _vm.activityData.endTime
                  )
                )
              ),
            ]),
          ]),
          _c("div", { staticClass: "info-item" }, [
            _c("span", { staticClass: "info-label" }, [_vm._v("活动时间")]),
            _c("span", { staticClass: "info-value" }, [
              _vm._v(
                _vm._s(
                  _vm.formatTimeRange(
                    _vm.activityData.marketStartTime,
                    _vm.activityData.marketEndTime
                  )
                )
              ),
            ]),
          ]),
          _c("div", { staticClass: "info-item info-item-block" }, [
            _c("span", { staticClass: "info-label" }, [_vm._v("活动时间备注")]),
            _c("span", { staticClass: "info-value info-value-wrap" }, [
              _vm._v(_vm._s(_vm.activityData.timeRemark || "暂无")),
            ]),
          ]),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "detail-section" }, [
      _vm._m(2),
      _c("div", { staticClass: "section-content" }, [
        _vm.bulletScreenList.length > 0
          ? _c(
              "div",
              { staticClass: "bullet-screen-list" },
              _vm._l(_vm.bulletScreenList, function (tag, index) {
                return _c(
                  "el-tag",
                  {
                    key: tag + "-" + index,
                    staticClass: "bullet-screen-tag",
                    attrs: { type: "info", effect: "plain" },
                  },
                  [_vm._v(" " + _vm._s(tag) + " ")]
                )
              }),
              1
            )
          : _c("div", { staticClass: "no-content" }, [
              _c("i", { staticClass: "el-icon-message" }),
              _c("span", [_vm._v("暂无弹幕配置")]),
            ]),
      ]),
    ]),
    _c("div", { staticClass: "detail-section" }, [
      _vm._m(3),
      _c("div", { staticClass: "section-content" }, [
        _c("div", { staticClass: "info-grid" }, [
          _c("div", { staticClass: "info-item" }, [
            _c("span", { staticClass: "info-label" }, [_vm._v("押金")]),
            _c("span", { staticClass: "info-value" }, [
              _vm._v(_vm._s(_vm.activityData.deposit || 0) + "元"),
            ]),
          ]),
          _c("div", { staticClass: "info-item" }, [
            _c("span", { staticClass: "info-label" }, [_vm._v("履约保证金")]),
            _c("span", { staticClass: "info-value" }, [
              _vm._v(_vm._s(_vm.activityData.performanceBond || 0) + "元"),
            ]),
          ]),
          _c("div", { staticClass: "info-item" }, [
            _c("span", { staticClass: "info-label" }, [_vm._v("押金规则")]),
            _c("span", { staticClass: "info-value" }, [
              _vm._v(_vm._s(_vm.activityData.depositRule || "暂无")),
            ]),
          ]),
          _vm.activityData.commissionStatus === 1
            ? _c("div", { staticClass: "info-item" }, [
                _c("span", { staticClass: "info-label" }, [_vm._v("抽成状态")]),
                _c(
                  "span",
                  { staticClass: "info-value" },
                  [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type:
                            _vm.activityData.commissionStatus === 1
                              ? "success"
                              : "info",
                          size: "mini",
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.activityData.commissionStatus === 1
                                ? "开启"
                                : "关闭"
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm.activityData.commissionStatus === 1
            ? _c("div", { staticClass: "info-item" }, [
                _c("span", { staticClass: "info-label" }, [_vm._v("抽成比例")]),
                _c("span", { staticClass: "info-value" }, [
                  _vm._v(_vm._s(_vm.activityData.commission || 0) + "%"),
                ]),
              ])
            : _vm._e(),
        ]),
        _vm.activityExtList.length > 0
          ? _c("div", { staticClass: "ext-fees" }, [
              _c("div", { staticClass: "ext-fees-title" }, [
                _vm._v("扩展费用"),
              ]),
              _c(
                "div",
                { staticClass: "ext-fees-list" },
                _vm._l(_vm.activityExtList, function (fee, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "ext-fee-item" },
                    [
                      _c("div", { staticClass: "fee-info" }, [
                        fee.extName ||
                        fee.negotiable === 1 ||
                        (fee.commissionStatusExt !== undefined &&
                          fee.commissionStatusExt === 1 &&
                          fee.commissionExt)
                          ? _c("div", { staticClass: "fee-name-detail" }, [
                              _c("span", { staticClass: "fee-name" }, [
                                _vm._v(_vm._s(fee.extName || "费用")),
                              ]),
                            ])
                          : _vm._e(),
                        fee.negotiable === 1
                          ? _c("div", { staticClass: "negotiable-detail" }, [
                              _c("span", { staticClass: "negotiable-text" }, [
                                _vm._v("面议"),
                              ]),
                            ])
                          : _vm._e(),
                        _vm.hasFeeAmount(fee) &&
                        fee.negotiable !== 1 &&
                        !_vm.hasCommissionOnly(fee)
                          ? _c("div", { staticClass: "fee-detail" }, [
                              _c("span", { staticClass: "fee-amount" }, [
                                _vm.hasRangeFee(fee)
                                  ? _c("span", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.formatFeeAmount(fee.extFee)
                                          ) +
                                          "-" +
                                          _vm._s(
                                            _vm.formatFeeAmount(fee.extFeeMax)
                                          ) +
                                          "元 "
                                      ),
                                    ])
                                  : _c("span", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.formatSingleFee(fee.extFee)
                                          ) +
                                          " "
                                      ),
                                    ]),
                              ]),
                              Number(fee.extFee) !== 0 &&
                              fee.unitValue &&
                              fee.unit
                                ? _c("span", { staticClass: "fee-unit" }, [
                                    _vm._v(
                                      "/" +
                                        _vm._s(fee.unitValue) +
                                        _vm._s(fee.unit)
                                    ),
                                  ])
                                : _vm._e(),
                            ])
                          : _vm._e(),
                        fee.negotiable !== 1 &&
                        fee.extType !== undefined &&
                        _vm.hasFeeAmount(fee) &&
                        !_vm.hasCommissionOnly(fee)
                          ? _c(
                              "div",
                              { staticClass: "fee-type-tag" },
                              [
                                _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      type: _vm.getFeeTypeTag(fee),
                                      size: "mini",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.getFeeTypeText(fee)) +
                                        " "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        fee.commissionStatusExt !== undefined &&
                        fee.commissionStatusExt === 1 &&
                        fee.commissionExt &&
                        fee.negotiable !== 1
                          ? _c("div", { staticClass: "commission-detail" }, [
                              _c("span", { staticClass: "commission-label" }, [
                                _vm._v("抽成："),
                              ]),
                              _c("span", { staticClass: "commission-value" }, [
                                _vm._v(_vm._s(fee.commissionExt) + "%"),
                              ]),
                            ])
                          : _vm._e(),
                        fee.feeRemark
                          ? _c("div", { staticClass: "fee-remark-detail" }, [
                              _c("span", { staticClass: "remark-label" }, [
                                _vm._v("备注："),
                              ]),
                              _c("span", { staticClass: "remark-value" }, [
                                _vm._v(_vm._s(fee.feeRemark)),
                              ]),
                            ])
                          : _vm._e(),
                      ]),
                    ]
                  )
                }),
                0
              ),
            ])
          : _vm._e(),
      ]),
    ]),
    _c("div", { staticClass: "detail-section" }, [
      _vm._m(4),
      _c("div", { staticClass: "section-content" }, [
        _vm.activityImages.length > 0
          ? _c(
              "div",
              { staticClass: "image-gallery" },
              _vm._l(_vm.activityImages, function (img, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "image-item" },
                  [
                    _c("el-image", {
                      staticClass: "gallery-image",
                      attrs: {
                        src: img,
                        "preview-src-list": _vm.activityImages,
                        fit: "cover",
                      },
                    }),
                  ],
                  1
                )
              }),
              0
            )
          : _c("div", { staticClass: "no-images" }, [
              _c("i", { staticClass: "el-icon-picture-outline" }),
              _c("span", [_vm._v("暂无图片")]),
            ]),
      ]),
    ]),
    _c("div", { staticClass: "detail-section" }, [
      _vm._m(5),
      _c("div", { staticClass: "section-content" }, [
        _vm.activityData.activityInfo
          ? _c("div", {
              staticClass: "rich-content",
              domProps: { innerHTML: _vm._s(_vm.activityData.activityInfo) },
            })
          : _c("div", { staticClass: "no-content" }, [
              _c("i", { staticClass: "el-icon-document" }),
              _c("span", [_vm._v("暂无详情")]),
            ]),
      ]),
    ]),
    _vm.activityData.agreementStatus === 0
      ? _c("div", { staticClass: "detail-section" }, [
          _vm._m(6),
          _c("div", { staticClass: "section-content" }, [
            _vm.activityData.agreementInfo
              ? _c("div", {
                  staticClass: "rich-content",
                  domProps: {
                    innerHTML: _vm._s(_vm.activityData.agreementInfo),
                  },
                })
              : _c("div", { staticClass: "no-content" }, [
                  _c("i", { staticClass: "el-icon-document-copy" }),
                  _c("span", [_vm._v("暂无协议")]),
                ]),
          ]),
        ])
      : _vm._e(),
    _c("div", { staticClass: "detail-section" }, [
      _vm._m(7),
      _c("div", { staticClass: "section-content" }, [
        _vm.formConfigList.length > 0
          ? _c(
              "div",
              { staticClass: "form-config-list" },
              _vm._l(_vm.formConfigList, function (config, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "form-config-item" },
                  [
                    _c(
                      "el-checkbox",
                      { attrs: { value: true, disabled: "" } },
                      [_vm._v(_vm._s(config.label))]
                    ),
                  ],
                  1
                )
              }),
              0
            )
          : _c("div", { staticClass: "no-content" }, [
              _c("i", { staticClass: "el-icon-setting" }),
              _c("span", [_vm._v("暂无表单配置")]),
            ]),
      ]),
    ]),
    _vm.activityData.cancelRemark
      ? _c("div", { staticClass: "detail-section" }, [
          _vm._m(8),
          _c("div", { staticClass: "section-content" }, [
            _c("div", { staticClass: "remark-content" }, [
              _vm._v(_vm._s(_vm.activityData.cancelRemark)),
            ]),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-header" }, [
      _c("i", { staticClass: "el-icon-info section-icon" }),
      _c("span", { staticClass: "section-title" }, [_vm._v("基础信息")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-header" }, [
      _c("i", { staticClass: "el-icon-time section-icon" }),
      _c("span", { staticClass: "section-title" }, [_vm._v("时间信息")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-header" }, [
      _c("i", { staticClass: "el-icon-message section-icon" }),
      _c("span", { staticClass: "section-title" }, [_vm._v("详情弹幕配置")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-header" }, [
      _c("i", { staticClass: "el-icon-money section-icon" }),
      _c("span", { staticClass: "section-title" }, [_vm._v("费用信息")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-header" }, [
      _c("i", { staticClass: "el-icon-picture section-icon" }),
      _c("span", { staticClass: "section-title" }, [_vm._v("活动图片")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-header" }, [
      _c("i", { staticClass: "el-icon-document section-icon" }),
      _c("span", { staticClass: "section-title" }, [_vm._v("活动详情")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-header" }, [
      _c("i", { staticClass: "el-icon-document-copy section-icon" }),
      _c("span", { staticClass: "section-title" }, [_vm._v("协议详情")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-header" }, [
      _c("i", { staticClass: "el-icon-setting section-icon" }),
      _c("span", { staticClass: "section-title" }, [_vm._v("活动表单配置")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-header" }, [
      _c("i", { staticClass: "el-icon-edit-outline section-icon" }),
      _c("span", { staticClass: "section-title" }, [_vm._v("备注信息")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }